define('modules/lists/modals/views/list.quota.view',[
    'client',
    'jquery',
    'underscore',
    'backbone',
    'modules/base/modals/views/modal.view',
    "text!modules/lists/modals/templates/list.quota.view.html"
], function(
    Prospector,
    $, _,Backbone,
    ModalView,
    Template
){
    var ListQuotaView = ModalView.extend({
        template: _.template(Template),
        mEvents:function() {
            var base = {
            };
            var click = {
                'click .confYes' : 'procConfYes'
            };
            $.extend(base,click);
            return base;
        },
        initialize: function(options) {
            this.model = options.model;
            this.continue = options.passedFunc
        },
        onRender:function(){
            var needed = this.model.get('required');
            var remaining = this.model.get('limit') - this.model.get('used');
            var extraNeeded = needed - remaining;

            var neededTxt = this.buildProfilePullText(remaining);
            var extraNeededText = this.buildProfilePullText(extraNeeded);

            this.$('.numberProfilesAvailable').html(neededTxt);
            this.$('.numberProfilesNeeded').html(extraNeededText);

            ModalView.prototype.onRender.call(this);
        },
        buildProfilePullText:function(needed){
            var neededTxt = "";
            if(needed > 1){
                neededTxt = needed + " profile pulls";
            } else {
                neededTxt = "1 profile pull";
            }
            return neededTxt;
        },
        procConfYes:function(){
            this.continue();
            this.closeModal();
        }
    });
    return ListQuotaView;
});
